module.exports = __webpack_public_path__ + "static/media/card-invoice.13798e4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/card-invoice.png
// module id = 1790
// module chunks = 0